import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["days", "currentMonth", "webinarsList"]
  static values = {
    webinarDates: { type: Array, default: [] }
  }

  connect() {
    this.currentDate = new Date()
    this.currentMonth = this.currentDate.getMonth()
    this.currentYear = this.currentDate.getFullYear()

    // Initialize calendar
    this.renderCalendar()
  }

  renderCalendar() {
    // Update month and year display
    this.currentMonthTarget.textContent = new Date(this.currentYear, this.currentMonth, 1)
      .toLocaleDateString('en-US', { month: 'long', year: 'numeric' })

    // Clear previous calendar days
    this.daysTarget.innerHTML = ''

    // Get first day of month and total days in month
    const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1).getDay()
    const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate()

    // Add empty cells for days before first day of month
    for (let i = 0; i < firstDayOfMonth; i++) {
      const emptyDay = document.createElement('div')
      emptyDay.classList.add('h-8', 'w-8', 'mx-auto')
      this.daysTarget.appendChild(emptyDay)
    }

    // Add days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const dayElement = document.createElement('div')
      dayElement.classList.add('text-center', 'py-1')

      const dateString = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      const isToday = day === this.currentDate.getDate() &&
                      this.currentMonth === this.currentDate.getMonth() &&
                      this.currentYear === this.currentDate.getFullYear()
      const hasWebinar = Array.isArray(this.webinarDatesValue) && this.webinarDatesValue.includes(dateString)

      const dayButton = document.createElement('button')
      dayButton.textContent = day
      dayButton.classList.add('h-8', 'w-8', 'rounded-full', 'mx-auto', 'flex', 'items-center', 'justify-center', 'text-sm', 'cursor-pointer')
      dayButton.dataset.action = "click->webinar-calendar#filterByDate"
      dayButton.dataset.webinarCalendarDateParam = dateString

      if (isToday) {
        dayButton.classList.add('bg-primary', 'text-white')
      } else if (hasWebinar) {
        dayButton.classList.add('bg-gray-100', 'bg-opacity-10', 'font-medium', 'border', 'border-gray-300')
      } else {
        dayButton.classList.add('hover:bg-gray-100')
      }

      // Always add outline for days with webinars, regardless of other styles
      if (hasWebinar) {
        dayButton.dataset.hasWebinar = "true"
      }

      dayElement.appendChild(dayButton)
      this.daysTarget.appendChild(dayElement)
    }
  }

  prevMonth() {
    this.currentMonth--
    if (this.currentMonth < 0) {
      this.currentMonth = 11
      this.currentYear--
    }
    this.renderCalendar()
  }

  nextMonth() {
    this.currentMonth++
    if (this.currentMonth > 11) {
      this.currentMonth = 0
      this.currentYear++
    }
    this.renderCalendar()
  }

  filterByDate(event) {
    const dateString = event.currentTarget.dataset.webinarCalendarDateParam

    // Fetch webinars for the selected date using Turbo
    const frame = document.getElementById('webinar_list')
    frame.src = `/webinars/filter_by_date?date=${dateString}`

    // Remove selected class from all days
    this.daysTarget.querySelectorAll('button').forEach(btn => {
      if (btn.classList.contains('bg-primary-dark')) {
        btn.classList.remove('bg-primary', 'text-white', 'bg-primary-dark')
        btn.classList.add('bg-white', 'text-black')

        // Restore the border for days with webinars
        if (btn.dataset.hasWebinar === "true") {
          btn.classList.add('border', 'border-gray-300')
        }
      }
    })

    // Add selected class to clicked day
    const isToday = dateString === this.currentDate.toISOString().split('T')[0]
    if (!isToday) {
      event.currentTarget.classList.remove('bg-opacity-10')
      event.currentTarget.classList.add('bg-primary-dark', 'text-white')

      // Keep the border for selected days with webinars, but change color
      if (event.currentTarget.dataset.hasWebinar === "true") {
        event.currentTarget.classList.remove('border-gray-300')
        event.currentTarget.classList.add('border', 'border-primary')
      }
    }
  }
}
